/*
 *  EventHandler is a great class to handle custom events and is way faster than jQuery
 *
 *  EventHandler.bind   (eventName:String, callback:Function )          Subscribe on a certain event
 *  EventHandler.trigger(eventName:String, arguments...      )          Trigger the event with a certain amount of arguments
 *  EventHandler.unbind (eventName:String, callback:Function )          Unsubscribe to a certain event
 *
 *  @author Edwin Veldhuizen <info@edwin.pw>
 */
var EventHandler = (function() {
    'use strict';

    var cache = {},

    trigger = function(topic) {
        if (cache[topic]) {
            var thisTopic = cache[topic],
                i = thisTopic.length,
                args = Array.prototype.slice.call(arguments);

            args.shift();
            while (i--) {
                var boundObject = thisTopic[i];
                if (boundObject.scope == null) {
                    boundObject.callback.apply(topic, args);
                } else {
                    var scope = args[0];
                    if (boundObject.scope[0] === scope[0] || boundObject.scope.find(scope).length !== 0 || boundObject.scope.closest(scope).length !== 0) {
                        boundObject.callback.apply(topic, args);
                    }
                }
            }
        }
    },

    bind = function(topic, scope, callback) {
        if (!cache[topic]) cache[topic] = [];

        if (callback == null) {
            callback = scope;
            scope = null;
        }

        cache[topic].unshift({
            scope: scope,
            callback: callback
        });
        return [topic, scope, callback];
    },

    unbind = function(topic, destroy) {
        var thisTopic = cache[topic];

        if (thisTopic) {
            if (destroy) {
                delete cache[topic];
            }
        }
    };

    return {
        trigger: trigger,
        bind: bind,
        unbind: unbind
    };
}());
